import { useTranslation } from "next-i18next";

import { Button, Illustration, Text } from "@/components/elements";

import styles from "./styles.module.css";

export const SubscribeSuccess = ({ dismiss }) => {
  const { t } = useTranslation();
  const key = "newsletter_banner.success";
  return (
    <>
      <Illustration type="world" className={styles.illustration} />
      <Text as="h2" size="l" className={styles.title}>
        {t(`${key}.title`)}
      </Text>
      <Text className={styles.content}>{t(`${key}.content`)}</Text>
      <Button onClick={dismiss} width="full">
        {t(`${key}.cta`)}
      </Button>
    </>
  );
};
